export default __webpack_public_path__ + "static/media/Hokky1 (2).ba04fbd4.gif";